export default __webpack_public_path__ + "static/media/right-arrow-blue-small.d12d499d.svg";